import React, { useState } from "react";
import { useField, useFormikContext } from "formik";
import { TFormValues } from "../../types";

import { GuideContext } from "../../../../components/GatewayForm/GatewayForm.store";

import Button from "../../../Button/Button";
import { Outcomes, Concerns } from "../../config/questionOptions";

const EligibleIntro: React.FC<{}> = () => {
  const { setCurrentStep, currentStep } = React.useContext(GuideContext);
  const { values } = useFormikContext<TFormValues>();
  return (
    <>
      <div>
        <div>Where is the concern occurring?</div>
        <div
          style={{
            width: "max-content",
            padding: "5px 10px",
            backgroundColor: "white",
            borderRadius: "5px",
            marginTop: "5px",
            textTransform: "uppercase",
          }}
          onClick={() => {
            setCurrentStep("legal-step-two");
          }}
        >
          {values.location}
          <svg
            style={{ alignSelf: "center", marginLeft: "5px" }}
            width="13"
            height="13"
            viewBox="0 0 13 13"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M12.3537 1.23104L11.7655 0.642876C11.3415 0.218853 10.7807 0 10.2199 0C9.65911 0 9.09831 0.218853 8.67428 0.642876L0.658864 8.65828C0.508405 8.80874 0.412657 9.00024 0.385301 9.20541L0.00231361 12.4745C-0.0250427 12.7617 0.193811 12.9943 0.467375 12.9943C0.481053 12.9943 0.508405 12.9943 0.522083 12.9943L3.79117 12.6113C3.99634 12.5839 4.20152 12.4882 4.3383 12.3377L12.3537 4.3223C13.2154 3.47425 13.2154 2.09276 12.3537 1.23104ZM1.82151 8.87714L8.41439 2.28426L10.7123 4.58219L4.11944 11.1751L1.82151 8.87714ZM1.31542 9.7799L3.21669 11.6812L1.05554 11.9274L1.31542 9.7799ZM11.6561 3.63839L11.4099 3.88461L9.11198 1.58667L9.35819 1.34046C9.59072 1.10793 9.89163 0.98483 10.2062 0.98483C10.5208 0.98483 10.8354 1.10793 11.0543 1.34046L11.6424 1.92862C11.875 2.16115 11.9981 2.46207 11.9981 2.77667C12.0118 3.10494 11.8887 3.40586 11.6561 3.63839Z"
              fill="black"
            />
          </svg>
        </div>
      </div>
      <div>
        <div>What are you most concerned about?</div>
        <div
          style={{
            width: "max-content",
            padding: "5px 10px",
            backgroundColor: "white",
            borderRadius: "5px",
          }}
          onClick={() => {
            setCurrentStep("legal-step-five");
          }}
        >
          {Concerns.find((concern) => concern.value === values.concern)?.label}
          <svg
            style={{ alignSelf: "center", marginLeft: "5px" }}
            width="13"
            height="13"
            viewBox="0 0 13 13"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M12.3537 1.23104L11.7655 0.642876C11.3415 0.218853 10.7807 0 10.2199 0C9.65911 0 9.09831 0.218853 8.67428 0.642876L0.658864 8.65828C0.508405 8.80874 0.412657 9.00024 0.385301 9.20541L0.00231361 12.4745C-0.0250427 12.7617 0.193811 12.9943 0.467375 12.9943C0.481053 12.9943 0.508405 12.9943 0.522083 12.9943L3.79117 12.6113C3.99634 12.5839 4.20152 12.4882 4.3383 12.3377L12.3537 4.3223C13.2154 3.47425 13.2154 2.09276 12.3537 1.23104ZM1.82151 8.87714L8.41439 2.28426L10.7123 4.58219L4.11944 11.1751L1.82151 8.87714ZM1.31542 9.7799L3.21669 11.6812L1.05554 11.9274L1.31542 9.7799ZM11.6561 3.63839L11.4099 3.88461L9.11198 1.58667L9.35819 1.34046C9.59072 1.10793 9.89163 0.98483 10.2062 0.98483C10.5208 0.98483 10.8354 1.10793 11.0543 1.34046L11.6424 1.92862C11.875 2.16115 11.9981 2.46207 11.9981 2.77667C12.0118 3.10494 11.8887 3.40586 11.6561 3.63839Z"
              fill="black"
            />
          </svg>
        </div>
      </div>
      <div>
        <div>What outcome would you like to achieve</div>
        {values.outcomes?.map((outcomeValue) => {
          return (
            <div
              style={{
                width: "max-content",
                padding: "5px 10px",
                backgroundColor: "white",
                borderRadius: "5px",
                marginTop: "5px",
              }}
              onClick={() => {
                setCurrentStep("legal-step-six");
              }}
            >
              {Outcomes.find((outcome) => outcome.value === outcomeValue)?.label}
              <svg
                style={{ alignSelf: "center", marginLeft: "5px" }}
                width="13"
                height="13"
                viewBox="0 0 13 13"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M12.3537 1.23104L11.7655 0.642876C11.3415 0.218853 10.7807 0 10.2199 0C9.65911 0 9.09831 0.218853 8.67428 0.642876L0.658864 8.65828C0.508405 8.80874 0.412657 9.00024 0.385301 9.20541L0.00231361 12.4745C-0.0250427 12.7617 0.193811 12.9943 0.467375 12.9943C0.481053 12.9943 0.508405 12.9943 0.522083 12.9943L3.79117 12.6113C3.99634 12.5839 4.20152 12.4882 4.3383 12.3377L12.3537 4.3223C13.2154 3.47425 13.2154 2.09276 12.3537 1.23104ZM1.82151 8.87714L8.41439 2.28426L10.7123 4.58219L4.11944 11.1751L1.82151 8.87714ZM1.31542 9.7799L3.21669 11.6812L1.05554 11.9274L1.31542 9.7799ZM11.6561 3.63839L11.4099 3.88461L9.11198 1.58667L9.35819 1.34046C9.59072 1.10793 9.89163 0.98483 10.2062 0.98483C10.5208 0.98483 10.8354 1.10793 11.0543 1.34046L11.6424 1.92862C11.875 2.16115 11.9981 2.46207 11.9981 2.77667C12.0118 3.10494 11.8887 3.40586 11.6561 3.63839Z"
                  fill="black"
                />
              </svg>
            </div>
          );
        })}
      </div>
    </>
  );
};
export default EligibleIntro;
